module.exports = __webpack_public_path__ + "fonts/latoNormal.e631d273.ttf";